import * as React from 'react'

import { action, makeObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import { RouteComponentProps, withRouter } from 'react-router'

import MobileCommonStore from '~/client/src/mobile/stores/ui/MobileCommon.store'
import NotificationsStore from '~/client/src/shared/stores/domain/Notifications.store'

interface IProps {
  common?: MobileCommonStore
  notificationsStore?: NotificationsStore
}

@inject('common', 'notificationsStore')
@observer
class NotificationCountLabel extends React.Component<
  IProps & RouteComponentProps<any>
> {
  public constructor(props: IProps & RouteComponentProps<any>) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const { unreadNotificationsCount } = this.props.notificationsStore
    if (!unreadNotificationsCount) {
      return null
    }

    return (
      <div className="col no-grow indication-click">
        <div
          className="br-rounded bg-red text white h15 w20 row x-center y-center"
          onClick={this.navigateToNotifications}
        >
          {unreadNotificationsCount}
        </div>
      </div>
    )
  }

  @action.bound
  private navigateToNotifications(event) {
    event.stopPropagation()
    this.props.common.displayNotifications()
  }
}

export default withRouter(NotificationCountLabel)
